<template>
    <v-dialog v-model="getModalListarPortadorFinanceiro" persistent max-width="960px"
        transition="dialog-transition">
        <v-card outlined>
            <v-card-title>
                <v-btn color="primary" @click="cadastrarPortadorFinanceiro" outlined>Cadastrar</v-btn>
                <v-spacer></v-spacer>
                <v-text-field outlined dense v-model="search" append-icon="search" label="Pesquisar" single-line
                    hide-details>
                </v-text-field>
            </v-card-title>
            <v-card-text>
                <v-data-table :headers="headers" :items="getPortadoresFinanceiro" :search="search">
                    <template v-slot:item.action="{ item }">
                        <v-btn color="primary" outlined small @click="visualizarPortadorFinanceiro(item)">
                            Visualizar
                        </v-btn>
                    </template>
                </v-data-table>
            </v-card-text>
            <v-card-actions>
                <v-btn color="default" @click="setModalListarPortadorFinanceiro(false)" outlined>Voltar</v-btn>
            </v-card-actions>
        </v-card>
        <ModalCadastro />
    </v-dialog>
</template>

<script>
    import ModalCadastro from "@/pages/financeiro/portador/ModalCadastro"
    import { mapGetters, mapActions } from "vuex"

    export default {
        components: {
            ModalCadastro
        },
        data() {
            return {
                search: '',
                headers: [
                    { text: '#', value: 'id', sortable: false },
                    { text: 'Nome', align: 'left', sortable: false, value: 'nome' },
                    { text: 'Ações', value: 'action', sortable: false }
                ],
                funcionarios: [],
            }
        },
        computed: {
            ...mapGetters([
                'getPortadoresFinanceiro',
                'getModalCadastroPortadorFinanceiro',
                'getModalListarPortadorFinanceiro',
                
            ])
        },
        methods: {
            ...mapActions([
                'listarPortadorFinanceiro',
                'visualizarPortadorFinanceiro',
                'cadastrarPortadorFinanceiro',
                'setModalListarPortadorFinanceiro'
            ])
        },
        created() {
            this.listarPortadorFinanceiro()
        }
    }
</script>